import HomeSkeleton from "../components/skeletons/HomeSkeleton";
import ShopSkeleton from "../components/skeletons/ShopSkeleton";
import ShopDetailSkeleton from "../components/skeletons/ShopDetailSkeleton";
import AboutSkeleton from "../components/skeletons/AboutSkeleton";
import FaqSkeleton from "../components/skeletons/FaqSkeleton";

// Maps a pathname to the skeleton that best approximates the page that
// lives there. Shared by App.jsx (picking a skeleton for the very first
// paint, before the router has even mounted) and Root (picking a skeleton
// for the destination of an in-flight client-side navigation) so the two
// don't drift out of sync with each other or with the route table in
// App.jsx.
const routePageSkeletons = {
  "/": HomeSkeleton,
  "/about": AboutSkeleton,
  "/faq": FaqSkeleton,
  "/shop": ShopSkeleton,
};

export const getSkeletonForPathname = (pathname) =>
  routePageSkeletons[pathname] ||
  (/^\/shop\/[^/]+$/.test(pathname) ? ShopDetailSkeleton : null);
